<template>
  <div id="app" class="app">
    <!-- Sidebar -->
    <aside class="sidebar" :class="{ open: menuOpen }">
      <div>
        <div class="subtitle">Министерство спорта Республики Бурятия</div>
        <nav class="nav">
          <a v-if="!isLoggedIn" class="btn-link" href="/login" rel="noopener">ИС ЕКП</a>
          <a v-else class="btn-link" href="/ekp" rel="noopener">ИС ЕКП</a>
          <!--          <a class="btn-link" href="/CSP" target="_blank" rel="noopener">ИС СФ</a>-->
        </nav>
      </div>
    </aside>

    <!-- Overlay для мобильного меню -->
    <div v-if="menuOpen" class="overlay" @click="menuOpen = false"></div>

    <!-- Main -->
    <main class="main">
      <div class="card">
        <div class="card-header">
          <!-- Header с кнопкой меню -->
          <header class="topbar mx-2">
            <button class="menu-btn" @click="toggleMenu">
              <b-icon icon="list"></b-icon>
            </button>
          </header>
          <div class="card-title">Календарный план официальных физкультурных мероприятий и спортивных мероприятий Республики Бурятия</div>
        </div>

        <b-row class="m-2">
          <b-form-input
              class="filter-input"
              v-model="filterRow"
              placeholder="Поиск..."
          />
        </b-row>
        <b-row class="mx-1">
          <b-col lg="4" class="mt-1">
            <b-form-select
                v-model="filterSetting.org_id"
                :options="orgList"
            />
          </b-col>
          <b-col lg="4" class="mt-1">
            <b-input-group>
              <b-form-select
                  v-model="selectedM"
                  :options="monthList"
                  @input="setPeriodM"
              />
              <b-form-select
                  v-model="selectedY"
                  :options="yearList"
                  @input="setPeriodY"
              />
            </b-input-group>
          </b-col>
          <b-col class="mt-1">
            <div class="card-tools">
              <b-button variant="outline-primary" @click="loadData" class="btn">Обновить</b-button>
              <span class="status">{{ status }}</span>
            </div>
          </b-col>
        </b-row>
        <b-table
            striped
            hover
            sticky-header="60vh"
            :items="rows"
            :fields="fields"
            show-empty
            class="data-table mt-1"
            :filter="filterRow"
        />
      </div>
    </main>
  </div>
</template>

<script>
import dataService from '../utils/dataService'
import tokenService from "@/services/token.service";

export default {
  name: "App",
  data() {
    return {
      endpoint: "http://localhost:8091/api/option/eventkind",
      rows: [],
      columns: [],
      loading: true,
      error: null,
      status: "",
      menuOpen: false,
      filterRow: '',
      fields: [
        {key: 'dateEvent', label: 'Дата проведения'},
        {key: 'nameEvent', label: 'Наименование мероприятия'},
        {key: 'federation', label: 'Федерация'},
        {key: 'location', label: 'Объект спорта'}
      ],
      monthList: [
        {value: 0, text: 'Январь'},
        {value: 1, text: 'Февраль'},
        {value: 2, text: 'Март'},
        {value: 3, text: 'Апрель'},
        {value: 4, text: 'Май'},
        {value: 5, text: 'Июнь'},
        {value: 6, text: 'Июль'},
        {value: 7, text: 'Август'},
        {value: 8, text: 'Сентябрь'},
        {value: 9, text: 'Октябрь'},
        {value: 10, text: 'Ноябрь'},
        {value: 11, text: 'Декабрь'},
      ],
      yearList: [],
      selectedM: new Date().getMonth(),
      selectedY: new Date().getFullYear(),
      filterSetting: {org_id: 1},
      orgList: []
    };
  },
  methods: {
    async loadOrg() {
      try {
        dataService.getListOrgOption().then((res) => {
          this.orgList = Array.isArray(res.data) ? res.data :
              (res.data && res.data.data) ||
              (res.data && res.data.rows) ||
              (res.data && res.data.items) ||
              [];
        })
      } catch (e) {
        this.error = "Ошибка загрузки организаций: " + e.message;
        this.status = "Ошибка";
      } finally {
        this.loading = false;
      }
    },
    async loadData() {
      this.loading = true;
      this.error = null;
      this.status = "Загрузка…";
      try {
        const res = await dataService.getEventList(this.filterSetting)
        const rows = Array.isArray(res.data.list)
            ? (res.data && res.data.list)
            : (res.data.list && res.data.list.data)
            || (res.data.list && res.data.list.rows)
            || (res.data.list && res.data.list.items)
            || [];
        this.rows = rows;
        this.columns = rows.length ? Object.keys(rows[0]) : [];
        this.status = "Обновлено: " + new Date().toLocaleString();
      } catch (e) {
        this.error = "Ошибка загрузки: " + e.message;
        this.status = "Ошибка";
      } finally {
        this.loading = false;
      }
    },
    format(val) {
      if (val == null) {
        return "";
      }
      if (typeof val === "object") {
        return JSON.stringify(val);
      }
      return val;
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    setPeriodM(month) {
      this.setPeriod(month, this.selectedY, 1)
    },
    setPeriodY(year) {
      this.setPeriod(this.selectedM, year, 1)
    },
    setPeriod(month, year) {
      let startDay = new Date(year, month, 1);
      let endDay = new Date(year, month + 1, 0);
      const formatter = new Intl.DateTimeFormat('en-CA', {day: '2-digit', month: '2-digit', year: 'numeric'});
      this.filterSetting.dat1 = formatter.format(startDay)
      this.filterSetting.dat2 = formatter.format(endDay)
      this.loadData()
    },
  },
  mounted() {
    let yNow = new Date().getFullYear();
    for (let i = yNow; i >= yNow - 2; i--) {
      this.yearList.push(i)
    }
    this.loadOrg()
    // this.setPeriod(this.selectedM, this.selectedY);
    this.$nextTick(() => {
      this.setPeriod(this.selectedM + 1, this.selectedY); // поправка месяца
    });
  },
  computed: {
    isLoggedIn: function () {
      return tokenService.getUser() != null
    },
  },
  watch: {
    'filterSetting.org_id': function (val) {
      this.filterSetting.org_id = val
      this.loadData()
    }
  },
};
</script>

<style>
body, html, #app {
  margin: 0;
  height: 100%;
  font-family: system-ui, sans-serif;
  background: #f6f7f9;
  color: #0f172a;
}

.app {
  display: flex;
  height: 100%;
  position: relative;
}

/* Sidebar */
.sidebar {
  width: 240px;
  background: #2A5C8D;
  background: linear-gradient(180deg, rgba(42, 92, 141, 1) 0%, rgba(53, 54, 61, 1) 50%);
  color: #fff;
  padding: 20px;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease;
}

.title {
  font-size: 18px;
  font-weight: 700;
}

.subtitle {
  color: #cbd5e1;
  font-size: 12px;
  margin: 8px 0 12px;
}

.nav {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.btn-link {
  padding: 10px 14px;
  border-radius: 8px;
  background: #1f2937;
  color: #e5e7eb;
  text-decoration: none;
  text-align: center;
}

.btn-link:hover {
  background: #374151;
}

.footer {
  margin-top: auto;
  font-size: 12px;
  color: #94a3b8;
}

/* Overlay */
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 5;
}

/* Main */
.main {
  flex: 1;
  padding: 28px;
  overflow: auto;
}

/* Topbar */
.topbar {
  display: none;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.menu-btn {
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  color: white;
  background-color: transparent;
}

.top-title {
  font-size: 18px;
  font-weight: 600;
}

/* Card */
.card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
  max-height: 100%;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  border-bottom: 1px solid #e2e8f0;
  color: white;
  background: #2A5C8D;
  background: linear-gradient(90deg, rgba(42, 92, 141, 1) 0%, rgba(53, 54, 61, 1) 50%);
}

.card-title {
  font-size: 16px;
  font-weight: 600;
}

.card-tools {
  display: flex;
  gap: 10px;
  align-items: center;
}

.btn {
  padding: 6px 14px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
}

.btn:hover {
  border-color: #cbd5e1;
}

.status {
  font-size: 12px;
  color: #64748b;
}

/* Table */
.table-wrap {
  overflow: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.data-table th, .data-table td {
  padding: 10px 14px;
  border: 1px solid #e2e8f0;
}

.data-table th {
  background: #2A5C8D;
  font-weight: 600;
  text-align: left;
  color: white;
}

.data-table tr:hover {
  background: #fafafa;
}

.empty {
  padding: 20px;
  text-align: center;
  color: #64748b;
}

.loader {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid #e5e7eb;
  border-top-color: #2563eb;
  animation: spin 1s linear infinite;
  display: inline-block;
  vertical-align: middle;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.note {
  margin-top: 12px;
  font-size: 12px;
  color: #64748b;
}

/* --- Адаптив --- */
@media (max-width: 720px) {
  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 10;
    transform: translateX(-100%);
  }

  .sidebar.open {
    transform: translateX(0);
  }

  .topbar {
    display: flex;
  }

  /* Добавим стиль для поля фильтра */
  .filter-input {
    padding: 6px 10px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 14px;
  }

  .filter-input:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 1px #2563eb;
  }

}
</style>
